import { render, staticRenderFns } from "./DocSimple.vue?vue&type=template&id=1eeb197c&"
import script from "./DocSimple.vue?vue&type=script&lang=js&"
export * from "./DocSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports